import { render, staticRenderFns } from "./MenuMobileModern.vue?vue&type=template&id=3b6aa695&scoped=true&"
import script from "./MenuMobileModern.vue?vue&type=script&lang=js&"
export * from "./MenuMobileModern.vue?vue&type=script&lang=js&"
import style0 from "./MenuMobileModern.vue?vue&type=style&index=0&id=3b6aa695&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6aa695",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Icon/index.vue').default,UiButton: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/index.vue').default,UiButtonIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/Icon.vue').default,FormTopLanguageSwitchModern: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Form/TopLanguageSwitchModern.vue').default})
